import React from 'react'

import { useNavigation } from '@zet/common/hooks/useNavigation'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { B5, SH3 } from '@zet/design-system/typography'
import { useUserContext } from '@zet/feature-user/api/user/hooks'

import { i18n } from '../../localization'
import SecureFilled from '../../svg/SecureFilled'
import VerificationPendingFilled from '../../svg/VerificationPendingFilled'

const MyCustomers = ({
  verified,
  nonVerified,
  customerAddedLastSevenDays,
  totalCount,
}) => {
  const { id } = useUserContext()
  const { navigate } = useNavigation()
  return (
    <Stack className="bg-neutral-white100 w-full px-3 py-3">
      <SH3 className="mb-2">
        {i18n.t('myCustomers.header')} ({totalCount})
      </SH3>
      <Stack className="border-grays-30  rounded border">
        <XStack className="bg-neutral-white100 rounded px-3 py-3">
          <Pressable
            onPress={() => navigate('MyCustomers', { subAgentId: id })}
            className="w-[50%] flex-row  "
          >
            <Stack className="bg-grays-20 h-6 w-6 items-center justify-center rounded">
              <SecureFilled />
            </Stack>
            <Stack className="ml-2">
              <SH3>{verified}</SH3>
              <B5
                className="text-grays-60
            "
              >
                {i18n.t('myCustomers.verified')}
              </B5>
            </Stack>
          </Pressable>
          <Stack className=" border-grays-30 border-r"></Stack>
          <Pressable
            onPress={() =>
              navigate('MyCustomers', {
                subAgentId: id,
                setRoute: 'NonVerifiedCustomers',
              })
            }
            className=" w-[50%] flex-row  pl-3"
          >
            <Stack className="bg-grays-20 h-6 w-6 items-center justify-center rounded">
              <VerificationPendingFilled />
            </Stack>
            <Stack className="ml-2">
              <SH3>{nonVerified}</SH3>
              <B5
                className="text-grays-60
            "
              >
                {i18n.t('myCustomers.nonVerified')}
              </B5>
            </Stack>
          </Pressable>
        </XStack>
        <Stack className="bg-primary-10 px-2 py-1">
          <B5 className="text-primary-200">
            {i18n.t('myCustomers.weeklyCustomers', {
              count: customerAddedLastSevenDays,
            })}
          </B5>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default MyCustomers
